const  isHaveChina = (str) => {
	if (escape(str).indexOf("%u") < 0) {
		return false
	}
  return true
}
export default {
  isHaveChina
} 